export const serverUrl =
	window.location.protocol + "//" + window.location.hostname;
